module.exports = __webpack_public_path__ + "img/DCIImg05.597fb9ba.png";